var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    _vm.as,
    { tag: "component", staticClass: "jade-group-header" },
    [
      _c(
        _vm.computedRenderElement,
        _vm._g(
          {
            tag: "component",
            class: _vm.computedClassContainer,
            attrs: { type: "button" },
          },
          _vm.$listeners
        ),
        [
          _c(
            "div",
            { staticClass: "jade-group-header__content" },
            [
              _c(
                "jade-text",
                {
                  attrs: {
                    variant: _vm.computedVariant,
                    color: _vm.computedColor,
                  },
                },
                [_vm.title ? [_vm._v(_vm._s(_vm.title))] : _vm._t("default")],
                2
              ),
            ],
            1
          ),
          _c(
            "div",
            [
              _vm.isInteractive
                ? _c("jade-icon", {
                    attrs: {
                      size: "medium",
                      color: "low",
                      use: "chevron-right",
                    },
                  })
                : _vm._e(),
              _vm._t("trailing"),
            ],
            2
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }